module PortalLibs.Client.Components.Progress


open Fable.Core
open Fable.Core.JsInterop
open Fable.React
open Fable.React.Props
open PortalLibs.Client.Util
open Fulma
open System
open Feliz


[<Import("default", from = "react-circular-progressbar")>]
let ReactProgress: obj = jsNative

importAll "react-circular-progressbar/dist/styles.css"


let CircleProgress =
  React.memo (
    "CircleProgress",
    (fun (props: {| percent: float
                    border: float
                    key: string |}) ->
      let props =
        createObj [
          //yield "value" => System.Math.Abs(percent)
          yield "percentage" => Math.Abs(props.percent)
          yield
            "text"
            => sprintf "%s%%" (Math.Round(props.percent, 2).ToString())
          yield "strokeWidth" => 50
          yield "initialAnimation" => true
          if (props.percent < 0.0) then
            yield "counterClockwise" => true
          yield
            "styles"
            => createObj [
                 "path"
                 => createObj [
                      "strokeLinecap" => "butt"
                      "stroke"
                      => if (props.percent < props.border) then
                           "red"
                         else
                           "#00cc00"
                      "transition" => "stroke-dashoffset 3s ease 0.5s"
                    ]
                 "trail" => createObj []
                 "text"
                 => createObj [
                      "fontSize" => "26px"
                      "fill" => "black"
                    ]
               ]
        ]

      div [ Style [
              Width "50px"
              Display DisplayOptions.Flex
              AlignItems AlignItemsOptions.Center
              FontWeight "bold"
            ] ] [
        ofImport "default" "react-circular-progressbar" props []
      ]),
    (fun (props: {| percent: float
                    border: float
                    key: string |}) -> props.key),
    areEqual = Helpers.equalsButFunctions
  )


let progressWithLabel name1 name2 value =
  div [ Style [
          MarginRight "15px"
          Width "150px"
          MarginBottom "15px"
        ] ] [
    div [ Style [
            Display DisplayOptions.Flex
            FlexDirection "column"
            Height "100%"
            Width "110px"
            JustifyContent "space-between"
          ] ] [
      div [ Style [ MarginBottom "5px" ] ] [
        Label.label [] [
          str name1
          br []
          str name2
        ]
      ]
      Control.div [ Control.Props [
                      Style [
                        Display DisplayOptions.Flex
                        JustifyContent "space-around"
                      ]
                    ] ] [
        CircleProgress(
          {| percent = value
             border = 0.0
             key = name1 + name2 |}
        )
      ]
    ]
  ]

[<Import("default", from = "react-svg-gauge")>]
let Gauge: obj = jsNative

let calcColor percent =
  let getHexColor (num: float) =
    let string = num.ToString("x")

    if string.Length = 1 then
      "0" + string
    else
      string

  let r =
    if percent > 0.0 then
      0.0
    else
      Math.Floor(Math.Abs(percent) * 2.55)

  let g =
    if percent < 0.0 then
      0.0
    else
      Math.Floor((percent + 20.0) * 2.55)

  let b = 0.0
  sprintf "#%s%s%s" (getHexColor r) (getHexColor g) (getHexColor b)


let GaugeProgress =
  React.memo (
    "GaugeProgress",
    (fun (props: {| percent: float; key: string |}) ->
      let gaugeProps =
        createObj [
          "value" => Math.Abs(props.percent)
          "width" => 80
          "height" => 64
          "color" => calcColor props.percent
          "topLabelStyle"
          => createObj [ "display" => "none" ]
          "minMaxLabelStyle"
          => createObj [ "display" => "none" ]
          "valueFormatter" => fun _ -> props.percent
          "valueLabelStyle"
          => createObj [
               yield "fontSize" => "14px"
               yield "fontWeight" => "bold"
               if props.percent < 0.0 then
                 yield "transform" => "scaleX(-1) translateX(-82px)"
             ]
        ]

      div [ Style [
              yield MarginTop "-18px"
              yield MarginBottom "-20px"
              if props.percent < 0.0 then
                yield Transform "scaleX(-1)"
              //Width "50px"
              //        Display DisplayOptions.Flex
              //        AlignItems AlignItemsOptions.Center
              //        FontWeight "bold"
              ] ] [
        ofImport "default" "react-svg-gauge" gaugeProps []
      ]),
    (fun (props: {| percent: float; key: string |}) -> props.key),
    areEqual = Helpers.equalsButFunctions
  )

//[<Import("Progress", from = "react-sweet-progress")>]
//let ReactProgress : obj = jsNative

//[<Import("", from = "react-sweet-progress/lib/style.css")>]
//let ReactProgressCSS : obj = jsNative

//let circleProgress (percent: float) =
//  let props =
//    createObj [ "percent" => percent
//       "status" => "default"
//       "theme" =>  createObj [ "default" => createObj [
//        "color" => if percent < 0.0 then "red" else "green"
//        "trailColor" => if percent < 0.0 then "pink" else "lightBlue"
//        ] ]
//       "type" => "circle"
//       "width" => 50
//       "strokeWidth" => 8
//     ]

//  div [ ] [ ofImport "Progress" "react-sweet-progress" props [] ]
